'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OutOfStockMedicationReportsIndicatorState(state) {
  this.Lapp_data_OutOfStockMedicationReportsIndicatorState__f_state = null;
  this.Lapp_data_OutOfStockMedicationReportsIndicatorState__f_state = state;
}
export { $c_Lapp_data_OutOfStockMedicationReportsIndicatorState as $c_Lapp_data_OutOfStockMedicationReportsIndicatorState };
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.constructor = $c_Lapp_data_OutOfStockMedicationReportsIndicatorState;
/** @constructor */
function $h_Lapp_data_OutOfStockMedicationReportsIndicatorState() {
}
export { $h_Lapp_data_OutOfStockMedicationReportsIndicatorState as $h_Lapp_data_OutOfStockMedicationReportsIndicatorState };
$h_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype = $c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype;
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-952562151), true);
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_OutOfStockMedicationReportsIndicatorState)) {
    var x = this.Lapp_data_OutOfStockMedicationReportsIndicatorState__f_state;
    var x$2 = x$0.Lapp_data_OutOfStockMedicationReportsIndicatorState__f_state;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.productPrefix__T = (function() {
  return "OutOfStockMedicationReportsIndicatorState";
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_OutOfStockMedicationReportsIndicatorState__f_state;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_OutOfStockMedicationReportsIndicatorState.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "state";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_OutOfStockMedicationReportsIndicatorState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_OutOfStockMedicationReportsIndicatorState)));
}
export { $isArrayOf_Lapp_data_OutOfStockMedicationReportsIndicatorState as $isArrayOf_Lapp_data_OutOfStockMedicationReportsIndicatorState };
var $d_Lapp_data_OutOfStockMedicationReportsIndicatorState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OutOfStockMedicationReportsIndicatorState, "app.data.OutOfStockMedicationReportsIndicatorState", ({
  Lapp_data_OutOfStockMedicationReportsIndicatorState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_OutOfStockMedicationReportsIndicatorState as $d_Lapp_data_OutOfStockMedicationReportsIndicatorState };
//# sourceMappingURL=app.data.-Out-Of-Stock-Medication-Reports-Indicator-State.js.map
